import { Component, AfterViewInit, Input, ViewChild, ElementRef } from '@angular/core';
import { IUProperty } from 'src/app/shared/interface/umbraco-property';
import { ISecurityPanelItemVm } from './components/security-panel-item/security-panel-item.component';
import { ISubtitleStyleSettings, ITitleStyleSettings } from '../../shared/interface/title-style-settings';
import { applyTitleSettings, applySubtitleSettings } from '../../shared/utils/title-style-settings-utils';

interface ISecurityPanelData {
  title?: IUProperty<string>;
  subtitle?: IUProperty<string>;
  capitalizeTitle?: IUProperty<string[]>;
  items: IUProperty<ISecurityPanelItemVm[]>;
  itemsHeaderSize?: IUProperty<string>;
  itemsHeaderFontWeight?: IUProperty<string>;

  titleStyleSettingsComposition?: ITitleStyleSettings;
  subtitleStyleSettingsComposition?: ISubtitleStyleSettings;
}

@Component({
  selector: 'app-security-panel',
  templateUrl: './security-panel.component.html',
  styleUrls: ['./security-panel.component.less']
})
export class SecurityPanelComponent implements AfterViewInit {
  @Input() data: ISecurityPanelData;
  @ViewChild('titleEl', { static: false }) titleEl: ElementRef<HTMLElement>;
  @ViewChild('subtitleEl', { static: false }) subtitleEl: ElementRef<HTMLElement>;
  @ViewChild('itemWrapperEl', { static: false }) itemWrapperEl: ElementRef<HTMLElement>;

  constructor(private hostRef: ElementRef) {}

  ngAfterViewInit(): void {
    if (this.data && this.data.capitalizeTitle && this.data.capitalizeTitle.value) {
      this.data.capitalizeTitle.value.forEach(item => {
        switch (item) {
          case 'Title': if (this.titleEl && this.titleEl.nativeElement) this.titleEl.nativeElement.style.textTransform = 'uppercase';
            break;
          case 'Subtitle': if (this.subtitleEl && this.subtitleEl.nativeElement) this.subtitleEl.nativeElement.style.transform = 'uppercase';
            break;
        }
      });
    }

    this.setCustomThemeProperties(this.data);
  }

  private setCustomThemeProperties(d: ISecurityPanelData) {
    applyTitleSettings(d, this.titleEl);
    applySubtitleSettings(d, this.subtitleEl);

    if (d.items.value.length > 0 && this.itemWrapperEl) { 
      if (d.itemsHeaderSize && d.itemsHeaderSize.value) {
        this.itemWrapperEl.nativeElement.style.setProperty("--security-panel-item-header-size",
          d.itemsHeaderSize.value + 'px');
      }
      if (d.itemsHeaderFontWeight && d.itemsHeaderFontWeight.value) {
        this.itemWrapperEl.nativeElement.style.setProperty("--security-panel-item-header-font-weight",
          d.itemsHeaderFontWeight.value);
      }
    }
  }
}
